<div
  class="ui attached segment"
  [ngClass]="{ loading: pending }"
  appMargin
  marginT="5"
  style="border: 1px solid #dcdcdc; border-radius: 4px"
  appPadding
  paddingX="40px"
>
  <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
    <!-- <div fxFlex="18">{{request2?.withdrawalRequestId || request?.withdrawalRequestId || 'null'}}</div> -->
    <div fxFlex="23">
      {{ request2?.transactionId || request?.transactionId || "null" }}
    </div>
    <div fxFlex="13">
      {{ request2?.currencyCode || request?.currencyCode || currencyCode }}
      {{ request?.amount | number: "1.2-2" }}
    </div>
    <div fxFlex="13">
      {{ request2?.currencyCode || request?.currencyCode || currencyCode }}
      {{ request?.totalCharges | number: "1.2-2" }}
    </div>
    <div fxFlex="13">
      <span
        class="ui grey circular label"
        [ngClass]="{
          green: request?.status === 'APPROVED',
          red: request?.status === 'REJECTED',
          yellow:
            request?.status === 'PENDING' ||
            request?.status.toLowerCase().includes('ongoing')
        }"
        >{{
          (request?.status.toLowerCase().includes("ongoing")
            ? "PENDING"
            : request?.status
          ) | uppercase
        }}</span
      >
    </div>
    <div fxFlex="23">
      {{ request?.dateCreated | date: "medium" }}
    </div>
    <div fxFlex="6">
      <div class="chat-icon" (click)="chatWithNCC()">
        <div
          class="status-indicator"
          *ngIf="
            request?.hasPendingComment == true ||
            request?.readComments < request?.totalComments
          "
        ></div>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="21"
          height="20"
          viewBox="0 0 21 20"
          fill="none"
        >
          <path
            d="M18.9805 0H2.98047C1.87747 0 0.980469 0.897 0.980469 2V20L6.31347 16H18.9805C20.0835 16 20.9805 15.103 20.9805 14V2C20.9805 0.897 20.0835 0 18.9805 0ZM18.9805 14H5.64747L2.98047 16V2H18.9805V14Z"
            fill="#3F4395"
          />
        </svg>
      </div>
    </div>
    <div fxFlex="12" class="text-right">
      <div class="ui basic primary dropdown" suiDropdown>
        <esl-button
          buttonType="primary"
          buttonSize="small"
          buttonState="outline"
          buttonActionState="default"
          [hasLine]="true"
          [hasSuffixIcon]="true"
          [buttonMenu]="'dropdownMenu'"
          [hasDropdown]="true"
          [isClickable]="true"
        ></esl-button>
        <div class="left menu actions-dropdown" suiDropdownMenu>
          <div class="item" (click)="viewDetails()">
            View Withdrawal Request Details
          </div>
          <div
            class="item"
            *ngIf="
              request?.status === 'PENDING' ||
              request?.status.toLowerCase().includes('ongoing')
            "
            (click)="cancelRequest(request)"
          >
            Cancel Request
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
